import { color } from "@smartsheet/design-tokens-react";
import { AlertErrorAltIcon, AlertWarningIcon, InfoIcon, CheckIcon } from "@smartsheet/lodestar-icons";
import { CheckInCircleIcon, ExclamationAlertErrorIcon, InfoIcon as InfoIconUrsa } from "@smartsheet/ursa-icons";
import React from "react";
import { Spinner } from "../../spinner";
const icons = {
  error: {
    "lodestar-light": /*#__PURE__*/React.createElement(AlertErrorAltIcon, {
      size: "small",
      role: "img",
      color: color("color--icons--error--weak")
    }),
    "ursa-light": /*#__PURE__*/React.createElement(ExclamationAlertErrorIcon, {
      size: 16,
      color: color("color--icons--error--default")
    })
  },
  warn: {
    "lodestar-light": /*#__PURE__*/React.createElement(AlertWarningIcon, {
      size: "small",
      role: "img",
      color: color("color--icons--warning--weak")
    }),
    "ursa-light": /*#__PURE__*/React.createElement(ExclamationAlertErrorIcon, {
      size: 16,
      color: color("color--icons--warning--default")
    })
  },
  info: {
    "lodestar-light": /*#__PURE__*/React.createElement(InfoIcon, {
      size: "small",
      role: "img"
    }),
    "ursa-light": /*#__PURE__*/React.createElement(InfoIconUrsa, {
      size: 16,
      color: color("color--text--neutral--weak")
    })
  },
  success: {
    "lodestar-light": /*#__PURE__*/React.createElement(CheckIcon, {
      size: "small",
      role: "img",
      color: color("color--icons--success--weak")
    }),
    "ursa-light": /*#__PURE__*/React.createElement(CheckInCircleIcon, {
      size: 16,
      color: color("color--icons--success--default")
    })
  }
};
export const iconBasedOnValidationState = (validationState, themeMode) => {
  if (validationState === "waiting") return /*#__PURE__*/React.createElement(Spinner, null);
  switch (themeMode) {
    // Lodestar and oldestar use the same Lodestar icon on purpose here. Oldestar never had a
    // FormLabel component so it was alright to use the new icons.
    case "oldestar":
    case "lodestar-light":
      return icons[validationState]["lodestar-light"];
    case "ursa-light":
    case "ursa-dark":
      return icons[validationState]["ursa-light"];
  }
};
//# sourceMappingURL=formLabelIcons.js.map